// extracted by mini-css-extract-plugin
export var button = "_ee-4";
export var hasDarkBackground = "_ee-7";
export var hasLightBackground = "_ee-6";
export var iconWrapper = "_ee-0";
export var large = "_ee-2";
export var medium = "_ee-1";
export var small = "_ee-5";
export var xsmall = "_ee-3";